import React from "react";
import { Modal, Skeleton } from "antd";
import ViewStreamComponent from "../../components/VideoStream";
import { VIEW_STREAM_SERVICE_EXTEND } from "../../constants/system.keys";

const ViewCameraPopup = ({ visible, camera, onCancel, gateways = [] }) => {
  return (
    <Modal
      title={camera?.name}
      centered
      visible={visible}
      onCancel={onCancel}
      width="40%"
      footer={false}
      getContainer={() => document.getElementById('main-live-page')}
      className="view-camera-popup"
    >
      {
        !!camera ? (
          <ViewStreamComponent
            name={camera.name}
            typeCamera={camera.typeCamera}
            resolution={camera.resolution}
            serviceId={VIEW_STREAM_SERVICE_EXTEND.normal}
            state={camera.state}
            serial={camera.serial}
            gatewaySerial={camera.gateways}
            thumbnail={camera.thumbnail}
            isInternal={
              gateways &&
              gateways.some(
                (gateway) =>
                  gateway.serial === camera.gatewaySerial
              )
            }
            permission={camera.permission}
            isAllowStreaming={camera.isAllowStreaming}
            isViewAll
          />
        ) : (
          <Skeleton.Button shape="square" active block />
        )
      }
    </Modal>
  )
}

export default ViewCameraPopup;